<div class="ion-text-left border-radius">
  @if (label) {
    <ion-label [ngClass]="baseCssClass">
      {{ label }}
    </ion-label>
  }

  <ion-item [disabled]="disabled" [lines]="disabled ? 'none' : 'full'" [ngClass]="{ 'ion-margin-vertical': false }">
    @if (icon) {
      <ion-icon [name]="icon" color="gray" slot="start"></ion-icon>
    }
    @if (disabled) {
      <ion-text [ngClass]="baseCssClass" class="readonly-text">
        {{ getPlaceholderValue() }}
      </ion-text>
    }

    <ion-select
      (ionChange)="onInputChange($event)"
      [multiple]="multiple"
      [ngClass]="[baseCssClass, disabled ? 'hidden' : '']"
      [placeholder]="placeholder ?? 'Select a value'"
      [value]="fieldValue">
      @for (value of possibleValues; track value; let i = $index) {
        <ion-select-option [value]="value">
          {{ !!this.possibleValuesLabels ? this.possibleValuesLabels[i] : camelCaseToDisplayString(value) }}
        </ion-select-option>
      }
    </ion-select>
  </ion-item>
</div>
